export default __webpack_public_path__ + "static/media/saleshandy-logo-text.f45e715f.svg";